import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const deleteEntireOrder = async (orderNumber: string) => {
    try {
        const response = await axios.delete(`${apiUrl}/Booking/deleteOrder/${orderNumber}`, 
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`
            }
        }
        );
        return response.data;
    } catch (error: any) {
        throw new Error(`Error deleting booking: ${error.message}`);
    }
};

export default deleteEntireOrder;